import type { RequiredGeneric } from '@pba/utils';
import { Col, Form, Radio, Row, useFormatPrice } from 'ui';
import { useItemSpanSize } from '../../../hooks';

export type AmountsFormValues = { amount?: number } | NonNullable<unknown>;

type P = {
  amounts: number[];
};

const AmountsFormContent = <T extends AmountsFormValues = never>({ amounts }: RequiredGeneric<T, P>) => {
  const itemSpanSize = useItemSpanSize();
  const formatPrice = useFormatPrice();

  return (
    <Form.Item<AmountsFormValues> dependencies={['showCustomAmount']} noStyle>
      {({ getFieldValue }) => {
        const isCustomAmount = getFieldValue('showCustomAmount') === true;

        return (
          <Form.Item<AmountsFormValues>
            label="Preset amounts"
            name="amount"
            rules={[{ required: !isCustomAmount }]}
            valuePropName={isCustomAmount ? 'notExistingPropName' : 'value'}
          >
            <Radio.Group disabled={isCustomAmount} fullWidth>
              <Row gutter={['xs', 'xs']}>
                {amounts.map((item, index) => (
                  <Col key={item} span={itemSpanSize(index, amounts.length)}>
                    <Radio.Button size="large" value={item}>
                      {formatPrice({ value: item })}
                    </Radio.Button>
                  </Col>
                ))}
              </Row>
            </Radio.Group>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default AmountsFormContent;
